var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fct-autocomplete',{staticStyle:{"width":"100%"},attrs:{"id":"physical-address","value":_vm.value,"onInputChange":_vm.placeAutoComplete},on:{"input":val => _vm.$emit('input', val)}})
}
var staticRenderFns = []

export { render, staticRenderFns }